import React from 'react';
import moment from 'moment';

const Crop = ({
  product: {
    crop,
    acreage,
    acreageSold,
    startDate,
    duration,
    projectedReturnsPerAcre,
    pricePerAcre,
    yieldPerAcre
  }
}) => {
  return (
    <div className="flex items-center">
      <div className="w-1/4">
        <img src={crop.imageUrl} alt={crop.name} />
      </div>
      <div className="w-3/4">
        <div className="bg-cf-100 py-3 px-8 rounded">
          <p className="text-sm font-bold">{crop.name}</p>
          <ul>
            <li>Opening date - {moment(startDate).format('MMM Do, YYYY')}</li>
            <li>Farm duration - {duration} months</li>
            <li>Farm size - {acreage + acreageSold} Acres</li>
            <li>Return After Harvest - ${projectedReturnsPerAcre}%</li>
            <li>Price per unit - ${pricePerAcre}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Crop;
